module.exports = __webpack_public_path__ + "static/media/ev1.ba7ba0c9.jpg";